namespace Areas.Dialogs {
    "use strict";

    let projectId: number;
    let ccIds: string = null;
    let fundSourceIds: string = null;

    let runCCQuery: boolean = false;
    let runFundQuery: boolean = false;


    export function getReportProjID() {
        return projectId;
    }

    export function canExecuteCCtrQuery() {
        return runCCQuery;
    }

    export function canExecuteFundsQuery() {
        return runFundQuery;
    }

    export function setProjIDFromSelection(e) {
        if (e.selectedItem == null) {
            projectId = null;
        } else {

            projectId = e.selectedItem.projectId;
            runCCQuery = true;
            runFundQuery = true;
        }
        Areas.refreshGrid("CCGrid");
        Areas.refreshGrid("FundGrid")

    }

    export class Report581Dialog extends Areas.BaseDialog {

        constructor(closeHandler: (dialogResult: DialogResult, data: any) => void,
            runProcessHandler: (data: any) => void,
            parameters: any = null,
            rootElementId: string = "dialog") {
            super("Report581Dialog",
                closeHandler,
                parameters,
                () => {

                    const form = $("#Report581DialogForm").dxForm("instance");
                    const reportData: any = form.option("formData");

                    if (parameters != null) {
                        reportData.projectId = parameters.projectId;
                        projectId = parameters.projectId;
                    }
                    reportData.showCost = false;

                    form.option("formData", reportData);

                },
                rootElementId,
                runProcessHandler);
        }

        protected runProcess = (e: any) => {

            const form = $("#Report581DialogForm").dxForm("instance");
            const result: any = form.validate();

            if (result.isValid) {

                const reportData: any = form.option("formData");
                const ccGrid = $("#CCGrid").dxDataGrid("instance");
                if (ccGrid.getSelectedRowsData().length > 0) {
                    ccIds = ccGrid.getSelectedRowsData().map(d => d.accountId).join(',');
                }

                const fundGrid = $("#FundGrid").dxDataGrid("instance");
                if (fundGrid.getSelectedRowsData().length > 0) {
                    fundSourceIds = fundGrid.getSelectedRowsData().map(d => d.fundingSourceId).join(',');
                }

                reportData.ccIds = ccIds;
                reportData.fundSourceIds = fundSourceIds;

                this.runProcessHandler(reportData)
            }

        }
    }


}
